import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DynamicWidgetFormComponent } from './dynamic-widget-form/dynamic-widget-form.component';
import { FieldBuilderComponent } from './field-builder/field-builder.component';
import { FieldArrayBuilderComponent } from './field-array-builder/field-array-builder.component';
import { MediaWidgetConfigurationComponent } from './field-builder/media-widget-configuration/media-widget-configuration.component';
import { DataSourceFactoryService } from './field-builder/field-builder-data-factory.service';
import { AutocompleteFieldConfigurationComponent } from './field-builder/autocomplete-field-configuration/autocomplete-field-configuration.component';
import { SelectFieldConfigurationComponent } from './field-builder/select-field-configuration/select-field-configuration.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { LabelValueListModule } from '../../gpp-shared/label-value-list/label-value-list.module';
import { RadioButtonConfigurationComponent } from './field-builder/radio-button-configuration/radio-button-configuration.component';
import { CheckboxConfigurationComponent } from './field-builder/checkbox-configuration/checkbox-configuration.component';
import { ColorPickerConfigurationComponent } from './field-builder/color-picker-configuration/color-picker-configuration.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { TextValueListModule } from '../text-value-list/text-value-list.module';
import { RichTextEditorModule } from '../rich-text-editor/rich-text-editor.module';
import { FieldGroupBuilderComponent } from './field-group-builder/field-group-builder.component';
import { EllipsisLabelTooltipModule } from '../utility-components/ellipsis-label-tooltip/ellipsis-label-tooltip.module';
import { CustomDataPanelComponent } from './custom-data-panel/custom-data-panel.component';
import { MatCardModule } from '@angular/material/card';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTooltipModule } from '@angular/material/tooltip';
@NgModule({
  declarations: [
    DynamicWidgetFormComponent,
    FieldArrayBuilderComponent,
    CustomDataPanelComponent,
    FieldBuilderComponent,
    RadioButtonConfigurationComponent,
    CheckboxConfigurationComponent,
    SelectFieldConfigurationComponent,
    ColorPickerConfigurationComponent,
    FieldGroupBuilderComponent,
    AutocompleteFieldConfigurationComponent,
    MediaWidgetConfigurationComponent,
  ],
  exports: [
    DynamicWidgetFormComponent,
    FieldBuilderComponent,
    FieldGroupBuilderComponent,
    FieldArrayBuilderComponent,
    CustomDataPanelComponent,
    MediaWidgetConfigurationComponent,
    AutocompleteFieldConfigurationComponent,
    RadioButtonConfigurationComponent,
    CheckboxConfigurationComponent,
    SelectFieldConfigurationComponent,
    ColorPickerConfigurationComponent
  ],
  providers: [DataSourceFactoryService],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    DragDropModule,
    LabelValueListModule,
    ColorPickerModule,
    TextValueListModule,
    RichTextEditorModule,
    EllipsisLabelTooltipModule,
    // material modules
    MatCardModule,
    MatIconModule,
    MatTooltipModule,
    MatInputModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatIconModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatStepperModule,
  ],
})
export class WidgetConfigurationModule {}
